export const loadingSteps = [
    {
        name: 'init',
        label: 'Starting data upload',
        status: 'running', // pending | running | completed
        icon: 'ic_refresh rotate' // ic_said-yes
    },
    {
        name: 'sync',
        label: 'Syncing, Please do not refresh this page',
        status: 'pending',
        icon: 'ic_logo-old' // ic_refresh rotate
    },
    {
        name: 'done',
        label: 'Synced successfully',
        status: 'pending',
        icon: 'ic_logo-old'
    }
]
